module.exports = __webpack_public_path__ + "static/media/sun.346b346f.svg";